"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _styles = require("@material-ui/core/styles");

var useStyles = (0, _styles.makeStyles)(function () {
  return {
    title: {
      fontWeight: 'bold'
    },
    grayScaled: {
      filter: 'grayscale(100%)'
    },
    logoWrapper: {
      display: 'inline-block',
      padding: '.75rem'
    },
    logo: {
      filter: 'grayscale(100%)',
      height: '70px',
      width: 'auto',
      minWidth: '100px',
      cursor: 'pointer',
      marginTop: '30px',
      transition: 'filter .5s ease-out',
      display: 'inline-block',
      '&:hover': {
        filter: 'grayscale(0%)'
      }
    }
  };
});
var _default = useStyles;
exports["default"] = _default;